import { useEffect, useState } from 'react';
import type { TermsResponse } from '../models/types';
import useLabels from './useLabels';

export default function useTerms({ active }: { active?: boolean; } = { active: true }) {
    //const { getTerms } = useAppInfo();

    const labels = useLabels();

    const [terms, setTerms] = useState<TermsResponse>();
    const [error, setError] = useState<Error>();
    const [isLoading, setIsLoading] = useState<boolean>(true);

    useEffect(() => {
        if (!active) return setIsLoading(false);

        //let promise: Promise<TermsResponse> | undefined;
        (async () => {
            setIsLoading(true);
            try {
                //promise = getTerms();
                //const terms = await promise;
                const terms = {
                    text: `<h4>PLUS+1® Assistant User Instruction</h4>
<p>
This User Instruction is intended to inform you of the limitations and usage guidelines of the PLUS+1 Assistant. 
Please read this Instruction carefully before using the PLUS+1 Assistant. 
</p>

<h4>General Information</h4>
<p>
By using PLUS+1 Assistant feature, you agree that you are interacting with a system based on artificial intelligence (AI) and not a Danfoss employee. 
The PLUS+1 Assistant generates responses based on algorithms and Danfoss data. 
</p>
<p>
The PLUS+1 Assistant is designed to provide information and assistance based publicly available PLUS+1 software documentation available on PLUS+1 Update Center. 
Misuse of the PLUS+1 Assistant may cause Danfoss to terminate your access. 
</p>
<p>
The PLUS+1 Assistant may display inaccurate, incomplete, or outdated information. 
We recommend that you verify all the relevant information received. The PLUS+1 Assistant does not reflect the opinion of Danfoss.
</p>

<h4>User Responsibility</h4>
<p>
As responses are automated and based on PLUS+1 software documentation available on PLUS+1 Update Center (to the extent released for PLUS+1 Assistant use) 
– you should always exercise caution and use good judgment if relying, using, or acting upon the responses given by the PLUS+1 Assistant. 
</p>
<p>
The PLUS+1 Assistant shall be used applying a respectful and constructive “dialogue”. As such, we kindly ask that you refrain from using any form of abusive or profane language. 
</p>

<h4>Data Safety and Security</h4>
<p>
We prioritize the privacy and security of our users' information. 
Be aware that chatbot conversations (questions and responses) may be reviewed by our content team to improve results. 
</p>
<p>
The PLUS+1 Assistant retains logs of these conversations for 30 days only. We process the content of your conversations in order to: 
</p>
<ul>
    <li>Provide support and respond to your specific inquiries. </li>
    <li>Improve your user experience by remembering the context of the current session. </li>
    <li>Your data is treated confidentially and is only disclosed to sub-processors (e.g., Microsoft Azure or OpenAI) 
    who are contractually obligated to protect your data and not use it to train or be available for their own models. </li>
</ul>
<p>Please do not share personal information, including but not limited to:</p>
<ul>
    <li>Full name</li>
    <li>Address</li>
    <li>Social security number</li>
    <li>Financial details</li>
    <li>Any other personally identifiable information</li>
</ul>
<p>
In particular, we strongly advise against sharing personal sensitive information, such as information on your health, race, political opinions, religious, philosophical beliefs, trade union membership, sexual orientation or other sensitive personal information.
This is to ensure your privacy and security. If personal data is nevertheless included in a conversation or response, such personal data will be processed solely for the purpose of enabling, operating, maintaining, securing, and improving the functionality and performance of the Danfoss PLUS+1 Assistant platform. 
Access to such data is restricted to authorized personnel with a legitimate business need, including relevant IT and support personnel. 
</p>
<p>
Users can delete conversations at any time in accordance with the platform’s available functionality. 
</p>
<p><strong>By using our PLUS+1® Assistant, you agree to have read and understood this User Instruction.</strong></p>`,
                } as TermsResponse;
                setTerms(terms);
            } catch (e) {
                console.error(e);
                setError(new Error(labels.termsApiError));
            } finally {
                setIsLoading(false);
            }
        })();
    }, [active,  labels.termsApiError]);

    return {
        terms,
        error,
        isLoading,
    };
}
